"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = keys => {
    const constants = {};
    keys.forEach(el => {
        constants[el] = el;
    });
    return constants;
};
